import React from 'react'
import SendIcon from '@mui/icons-material/Send';
import { Box, Button, CircularProgress, TextField, Typography, Paper } from '@mui/material'
import { useState, useRef } from 'react';
import { CameraAlt, Home, PhotoCamera } from '@mui/icons-material';
import { CustomModal } from '../components/Modal';
import { CameraComponent } from '../components/CameraComponent';
import { useNavigate } from 'react-router-dom';
import { useAppSelector } from '../redux/hooks';
import useIncidentes from '../hooks/useIncidentes';


export const Incidentes = () => {

    const navigate = useNavigate()
    const {createIncidente} = useIncidentes()
    const {casa,nombre} = useAppSelector((state) => state.auth.userData)!
    const fileInputRef = useRef<HTMLInputElement>(null)
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(false)
    const [showCamera, setShowCamera] = useState(false)
    const [openModal, setOpenModal] = useState(false)
    const [modalMessage, setModalMessage] = useState('')
    const [file, setFile] = useState(null) as any
    const [shouldNavigateHome, setShouldNavigateHome] = useState(false)

    const handleOpen = () => setOpenModal(true);
    const handleClose = () => {
        setOpenModal(false)
        if (shouldNavigateHome) {
            navigate('/home')
            setShouldNavigateHome(false)
        }
    }

    const openCamera = () => {
        setShowCamera(true);
    };

    const closeCamera = () => {
        setShowCamera(false);
    };

    const handleCameraCapture = (capturedFile: File) => {
        setFile(capturedFile);
        setShowCamera(false);
    };

    const handleFileSelect = () => {
        fileInputRef.current?.click();
    };

    const handleChange = async (file: any) => {
        if (!file){
            setFile(null)   
            return
        } 
        setFile(file);
    }

    const handleSubmit = async ( e : any ) => {
        e.preventDefault()
        const { tipo, nota } = e.target.elements

        if(file === null) {
            setModalMessage('Debe agregar una foto del incidente');
            setError(true);
            handleOpen();
            return
        }

        setLoading(true)
        
        let code = await createIncidente(tipo.value, nota.value, file)
        if (code) {
            setModalMessage('Incidente creado con éxito');
            setError(false);
            setShouldNavigateHome(true);
        }
        else {
            setModalMessage('Error al crear el incidente');
            setError(true);
        }

        setLoading(false)
        handleOpen()
    }



    return (
        <Box textAlign="center" display="flex" alignItems="center" flexDirection='column'>

            <Typography variant="h4" component="div" gutterBottom marginY='1em'>
                Crear Incidente
            </Typography>

            <Box component="form" display="flex" flexDirection="column" alignItems='center' width={0.8} maxWidth={500} onSubmit={handleSubmit} >

                <TextField fullWidth required disabled label="Casa" variant="outlined" sx={{marginY:2}}  value={`${casa} - ${nombre}`} />

                <TextField fullWidth required select name='tipo' label="Tipo" variant="outlined" sx={{marginY:2}}
                    SelectProps={{native: true}} defaultValue="1"
                >
                    <option value='1'>Garantía</option>
                    <option value='2'>Queja</option>
                    <option value='3'>Denuncia</option>
                    <option value='4'>Sugerencia</option>
                    <option value='5'>Otro</option>
                </TextField>

                <TextField multiline rows={2} fullWidth required label="Descripcion" name='nota' variant="outlined" sx={{marginY:2}} 
                    InputProps={{
                        inputProps: {
                            maxLength: 150
                        }
                    }}
                />

                <Paper 
                    elevation={3} 
                    sx={{
                        width: '100%',
                        padding: 3,
                        marginY: 2,
                        border: '2px dashed #ccc',
                        borderColor: file ? 'success.main' : 'grey.300',
                        backgroundColor: file ? 'success.50' : 'grey.50'
                    }}
                >
                    <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
                        {file ? (
                            <>
                                <Typography variant="h6" color="success.main">
                                    ✓ Archivo seleccionado
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    {file.name} ({(file.size / 1024 / 1024).toFixed(2)} MB)
                                </Typography>
                            </>
                        ) : (
                            <>
                                <Typography variant="h6">
                                    Seleccionar Foto/Video
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    Tome una foto o seleccione un archivo
                                </Typography>
                            </>
                        )}
                        
                        <Box display="flex" gap={2} flexWrap="wrap" justifyContent="center">
                            <Button
                                variant="contained"
                                startIcon={<CameraAlt />}
                                onClick={openCamera}
                                sx={{ minWidth: 120 }}
                            >
                                Cámara
                            </Button>

                            <Button
                                variant="outlined"
                                startIcon={<PhotoCamera />}
                                onClick={handleFileSelect}
                                sx={{ minWidth: 120 }}
                            >
                                Galería
                            </Button>
                        </Box>

                        <input
                            ref={fileInputRef}
                            type="file"
                            accept="image/*,video/*"
                            onChange={(e) => handleChange(e.target.files?.[0] || null)}
                            style={{ display: 'none' }}
                        />
                    </Box>
                </Paper>

                <Button type='submit' color='secondary' size='large' variant="contained"  sx={{marginY:2 , width:'50%'}}
                    disabled={loading}
                    endIcon={ loading ? <CircularProgress size={25} /> : <SendIcon/> }
                > 
                    Crear Incidente
                </Button>

            </Box>

            {/* Camera Component as Modal */}
            {showCamera && (
                <CameraComponent
                    isOpen={showCamera}
                    onClose={closeCamera}
                    onCapture={handleCameraCapture}
                />
            )}

            <CustomModal
                openState={openModal}
                onCloseHandler={handleClose}
            >
                
                <Typography variant="h6">
                    Incidentes
                </Typography>

                <Typography variant="h6" component="div" gutterBottom>
                    {modalMessage}
                </Typography>

                {!error && 
                <Button color='secondary' variant="outlined" endIcon={<Home/>}  sx={{marginY:2 , width:'50%'}} onClick={handleClose} >
                    Inicio
                </Button>}

                {error && 
                <Button color='secondary' variant="outlined" sx={{marginY:2 , width:'50%'}} onClick={handleClose} >
                    OK
                </Button>}

            </CustomModal>
            
        </Box>
    )


}
